export default "__VITE_ASSET__fa2e2ff3__"